import React from 'react';
import DataGrid from '../../components/Common/DataGrid';
import { getResellerSiteUrl } from '../../utils/resellerSiteUrl';
import { ratePct, rs } from '../format';
import { Button, StatusPill } from '../ui';

/** Reseller rows with figures and View / Record payout actions. Used on Overview and Resellers. */
const ResellerTable = ({ rows, onView, onPay, emptyText, simple }) => {
  const columns = [
    { title: 'Reseller', render: (r) => <><strong>{r.name}</strong><small>{r.business_name || 'Independent'}</small></>, value: (r) => `${r.name} ${r.business_name || ''} ${r.email} ${r.phone || ''}` },
    { title: 'Site', render: (r) => getResellerSiteUrl(r.subdomain, { withProtocol: false }), value: (r) => r.subdomain },
    { title: 'Status', render: (r) => <StatusPill status={r.status} />, value: (r) => r.status },
    { title: 'Conversions', numeric: true, render: (r) => r.conversions, value: (r) => r.conversions },
    { title: 'Rate', numeric: true, render: (r) => ratePct(r.commission_rate), value: (r) => r.commission_rate },
    { title: 'Earned', numeric: true, render: (r) => rs(r.commission), value: (r) => r.commission },
    {
      title: 'Balance owed',
      numeric: true,
      render: (r) => <span style={{ fontWeight: 800, color: r.commission_balance > 0 ? '#8a5a00' : '#5a6a7e' }}>{rs(r.commission_balance)}</span>,
      value: (r) => r.commission_balance,
    },
    {
      title: 'Actions',
      align: 'right',
      render: (r) => (
        <span style={{ whiteSpace: 'nowrap' }}>
          <Button size="sm" onClick={() => onView(r)}>View</Button>{' '}
          <Button size="sm" variant={r.commission_balance > 0 ? 'primary' : 'secondary'} disabled={r.commission_balance <= 0} onClick={() => onPay(r)}>Record payout</Button>
        </span>
      ),
    },
  ];
  return <DataGrid rows={rows} columns={columns} simple={simple} order={[[0, 'asc']]} emptyText={emptyText || 'No resellers yet'} />;
};

export default ResellerTable;
